module.exports = __webpack_public_path__ + "img/icon_dean_home_bg_card_icon_14.e275061f.png";